"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchExcludedPagesForSitemap = exports.fetchIncludedPagesForSitemap = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var fetchIncludedPagesForSitemap = function fetchIncludedPagesForSitemap($action) {
  return $action.ofType(_actions.PagesForSitemapsActionTypes.LOAD_INCLUDED_PAGES_FOR_SITE_MAP).pipe((0, _mergeMap.mergeMap)(function (action) {
    return (0, _fromPromise.fromPromise)(_API.default.getIncludedPagesForSitemap(action.payload)).pipe((0, _map.map)(function (response) {
      return _actions.FetchIncludedPagesForSitemap.success(response, action.payload);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchIncludedPagesForSitemap.failure(error, action.payload));
    }), (0, _startWith.startWith)(_actions.FetchIncludedPagesForSitemap.request(action.payload)));
  }));
};

exports.fetchIncludedPagesForSitemap = fetchIncludedPagesForSitemap;

var fetchExcludedPagesForSitemap = function fetchExcludedPagesForSitemap($action) {
  return $action.ofType(_actions.PagesForSitemapsActionTypes.LOAD_EXCLUDED_PAGES_FOR_SITE_MAP).pipe((0, _mergeMap.mergeMap)(function (action) {
    return (0, _fromPromise.fromPromise)(_API.default.getExcludedPagesForSitemap(action.payload)).pipe((0, _map.map)(function (response) {
      return _actions.FetchExcludedPagesForSitemap.success(response, action.payload);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchExcludedPagesForSitemap.failure(error, action.payload));
    }), (0, _startWith.startWith)(_actions.FetchExcludedPagesForSitemap.request(action.payload)));
  }));
};

exports.fetchExcludedPagesForSitemap = fetchExcludedPagesForSitemap;